import React, { Suspense, lazy } from 'react';
import { ThemeProvider, CssBaseline, CircularProgress, Box } from '@mui/material';
import theme from './utils/theme';
import { AuthProvider, NotificationProvider, StorageProvider, PlanProvider } from './contexts';
import AppRouter from './components/AppRouter';

/**
 * App Component (Refactored)
 * 
 * This is the new, simplified App component using Context API.
 * Reduced from 1205 lines to ~50 lines!
 * 
 * Architecture:
 * - NotificationProvider: Global notifications
 * - StorageProvider: Storage info (local + cloud)
 * - PlanProvider: Plan management (CRUD operations)
 * - AppRouter: Handles routing and main UI
 */

// Loading fallback for lazy-loaded components
const LoadingFallback = () => (
  <Box sx={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    minHeight: '100vh' 
  }}>
    <CircularProgress size={60} />
  </Box>
);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <NotificationProvider>
          <StorageProvider>
            <PlanProvider>
              <Suspense fallback={<LoadingFallback />}>
                <AppRouter />
              </Suspense>
            </PlanProvider>
          </StorageProvider>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;

